// extracted by mini-css-extract-plugin
export var measureBox = "_5c-0";